import classNames from "classnames";
import { FC, ReactNode, useEffect, useRef, useState } from "react";
import styles from "./ProgressBar.module.scss";

export const ProgressBar: FC<{
  children?: ReactNode;
  percent?: number;
}> = ({ children, percent }) => {
  const baseRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!baseRef.current || typeof window === "undefined") {
      return;
    }

    const watchMe = new IntersectionObserver(
      (entries) => {
        entries.forEach((change) => {
          if (change.isIntersecting) {
            setVisible(true);
            watchMe.disconnect();
          }
        });
      },
      {
        threshold: [0.1],
        rootMargin: "0px 0px -20% 0px",
      }
    );

    watchMe.observe(baseRef.current);

    return () => {
      watchMe.disconnect();
    };
  }, []);


  return (
    <div
      ref={baseRef}
      className={classNames(styles.base, { [styles.visible]: visible })}
    >
      <div className={styles.label}>{children}</div>
      <div className={styles.trail}>
        <div
          className={styles.bar}
          style={{ width: `${visible ? percent : 0}%` }}
        />
      </div>
    </div>
  );
};
